import { faQuestionCircle as solidQuestionCircle } from "@jewlr/pro-solid-svg-icons/faQuestionCircle"
import { FontAwesomeIcon } from "@jewlr/storybook/core"
import PropTypes from "prop-types"

import { FeesWrap, Text, Tooltip } from "areas/order/components"
import { IS_US } from "helpers/application"

const ResizeFees = ({ item, selectedSize }) => (
  <FeesWrap>
    <Text mb="10px">
      <strong>Resizing Fee:</strong> {selectedSize.fees.resizing_fee}
    </Text>
    {selectedSize.price > 0 && (
      <Text mb="10px">
        <strong>Size Surcharge:</strong> {selectedSize.fees.price}
      </Text>
    )}
    {item.resize_info?.has_base_engraving && (
      <>
        <Text mb="10px">
          <strong>Re-engraving Fee:</strong> {selectedSize.fees.reengraving_fee}{" "}
          <FontAwesomeIcon
            data-for="reengrave"
            data-tip
            icon={solidQuestionCircle}
          />
        </Text>
        <Tooltip id="reengrave">
          Your item has a custom base (inside the ring) engraving. We will need
          to re-engrave the inside of the ring again after resizing.
        </Tooltip>
      </>
    )}
    <Text mb="10px">
      <strong>Insured Shipping:</strong>{" "}
      {selectedSize.fees.two_way_shipping_fee || selectedSize.fees.shipping_fee}{" "}
      <FontAwesomeIcon
        data-for="insured_shipping"
        data-tip
        icon={solidQuestionCircle}
      />
    </Text>
    <Tooltip id="insured_shipping">
      {IS_US() ? (
        <>
          The Shipping fee is for a Secure Shipping Service which includes a
          prepaid shipping label which we email to you so that you can ship the
          ring to us, and{" "}
          <em>
            <strong>also</strong>
          </em>{" "}
          return shipping back to you. The package is insured both ways for the
          full value -{" "}
          <em>
            <strong>so you have nothing to worry about</strong>
          </em>
          . This service will ensure that your item{" "}
          <em>
            <strong>arrives at the appropriate facility</strong>
          </em>{" "}
          and expedites the resizing process.
        </>
      ) : (
        <>
          The Shipping fee is for a Secure Return Shipping Service to send the
          ring back to you. The package is insured for the full value -{" "}
          <em>
            <strong>so you have nothing to worry about.</strong>
          </em>
        </>
      )}
    </Tooltip>
    {selectedSize.fees.tax_label && (
      <Text mb="10px">
        <strong>{selectedSize.fees.tax_label}</strong>{" "}
        {selectedSize.fees.two_way_shipping_fee
          ? selectedSize.fees.tax_amount_two_way
          : selectedSize.fees.tax_amount}
      </Text>
    )}
    <Text>
      <strong>Total:</strong>{" "}
      {selectedSize.fees.two_way_shipping_fee
        ? selectedSize.fees.total_cost_two_way
        : selectedSize.fees.total_cost}
    </Text>
  </FeesWrap>
)

ResizeFees.propTypes = {
  item: PropTypes.object,
  selectedSize: PropTypes.object,
}

export default ResizeFees
